/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default [
  {
    path: "privateTask",
    component: () => import("@/pages/privateTask/List"),
    meta: { title: "任务创建", cate: "项目管理" },
    children:[
      {
        path: 'personnelList',
        component: () => import( /* webpackChunkName: "company-list" */ '@/pages/privateTask/personnelList/index'),
        meta: {
          title: '报名审核',
          cate: '项目管理'
        }
      },
      {
        path: ':view',
        name: 'privateTask_view',
        component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/mis/CreateEdit'),
        meta: {title:'任务详情'},
      }
    ]
  },
  {
    path: "taskCustomer",
    component: () => import("@/pages/customer/List"),
    meta: { title: "详情", cate: "结算管理" },
    children: [
      {
        path: 'import',
        component: () => import(/* webpackChunkName: "customer-list" */ '@/pages/customer/Import'),
        meta: {title:'导入数据'},
        hidden: true
      },
      {
        path: ':customer_id/view',
        component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/CreateEdit'),
        meta: {title:'查看结算清单'},
      },
      {
        path: 'exportpdf',
        component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/ExportPdf'),
        meta: {title:'导出协议', isShow: false},
      },
      {
        path: 'exportpdf-HSY',
        component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/customer/ExportPdfHSY'),
        meta: {title:'导出协议', isShow: false},
      }
    ]
  },
];
